import { match as locale } from "../../../src/params/locale.ts";

export const matchers = { locale };